export default "__VITE_ASSET__CooOuLdq__"